import { render, staticRenderFns } from "./customers-status-box.vue?vue&type=template&id=705052fc&scoped=true&"
import script from "./customers-status-box.vue?vue&type=script&lang=js&"
export * from "./customers-status-box.vue?vue&type=script&lang=js&"
import style0 from "./customers-status-box.vue?vue&type=style&index=0&id=705052fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705052fc",
  null
  
)

export default component.exports